import { ITimeZone } from '@shared/interfaces/app.interface';

/**
 * Prefer formatted timezone label, then name, then raw timezone id.
 */
export function getTimeZoneLabel(
  timezone: Partial<ITimeZone> | null | undefined,
): string {
  return (
    timezone?.formatted_timezone ||
    timezone?.timezone_name ||
    timezone?.timezone ||
    '-'
  );
}
